export class AddEnabledFeatureFlags {
  static readonly type = '[FeatureFlag State] AddFeatureFlag'
  constructor(public featureFlags: string[]) {}
}
